'use strict';

import Component from 'generic.basecomponent';
import menuManager from 'menu-manager';

export default class Profile extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.menuId = 'profile';
        this.isOpened = false;
        this.container.addEventListener("click", this.onProfileClick.bind(this));

        menuManager.init(this.menuId, {
            default: {
                open: this.open.bind(this),
                close: this.close.bind(this),
                level: 1
            },
            desktop: {
                isEnabled: false
            }
        });
    }

    open() {
        this.isOpened = true;
        this.container.classList.toggle("is-opened");
    }

    close() {
        this.isOpened = false;
        this.container.classList.remove("is-opened");
    }

    onProfileClick(e) {
        if (this.isOpened) {
            menuManager.close(this.menuId);
        } else {
            menuManager.open(this.menuId);
        }
    }
}

Profile.id = 0;



// WEBPACK FOOTER //
// ./app/components/profile/js/generic.profile.js